import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { makeLpSymbolCountersCache } from './_helpers/lpSymbolCountersCache';
import { makeLpSymbolCompositeId } from './_helpers/makeLpSymbolCompositeId';
import { SymbolLpAction } from './symbolLp.action';
import { symbolLpInitialState } from './symbolLp.constant';
import { ISymbolLpStore } from './symbolLp.interface';

export const symbolLpReducer = reducerWithInitialState(symbolLpInitialState)
  .cases([SymbolLpAction.loadList.started, SymbolLpAction.processing.started], (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Started,
      listError: undefined,
    };
  })
  .case(SymbolLpAction.loadList.done, (state, { params, result }): ISymbolLpStore => {
    const [key, counters] = makeLpSymbolCountersCache(params, result);

    return {
      ...state,
      counters: {
        ...state.counters,
        [key]: counters,
      },
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(SymbolLpAction.loadList.failed, (state, { error }) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Failed,
      listError: error,
    };
  })
  .case(SymbolLpAction.load.started, (state, { lpId, name }): ISymbolLpStore => {
    const { data } = state;
    const recordId = makeLpSymbolCompositeId(lpId, name);
    return {
      ...state,
      data: {
        ...data,
        [recordId]: {
          ...data[recordId],
          networkStatus: NetworkStatus.Started,
        },
      },
    };
  })
  .case(SymbolLpAction.load.done, (state, { params, result }): ISymbolLpStore => {
    const { lpId, name } = params;
    const { data } = state;
    const recordId = makeLpSymbolCompositeId(lpId, name);
    return {
      ...state,
      data: {
        ...data,
        [recordId]: {
          ...result,
          networkStatus: NetworkStatus.Done,
        },
      },
    };
  })
  .case(SymbolLpAction.load.failed, (state, { params }): ISymbolLpStore => {
    const { lpId, name } = params;
    const { data } = state;
    const recordId = makeLpSymbolCompositeId(lpId, name);
    return {
      ...state,
      data: {
        ...data,
        [recordId]: {
          ...data[recordId],
          networkStatus: NetworkStatus.Failed,
        },
      },
    };
  })
  .cases([SymbolLpAction.loadUnmapped.started], (state) => {
    return {
      ...state,
      unmappedSymbols: {
        ...state.unmappedSymbols,
        networkStatus: NetworkStatus.Started,
      },
    };
  })
  .case(SymbolLpAction.loadUnmapped.done, (state, { result }): ISymbolLpStore => {
    return {
      ...state,
      unmappedSymbols: {
        list: result,
        networkStatus: NetworkStatus.Done,
      },
    };
  })
  .case(SymbolLpAction.loadUnmapped.failed, (state) => {
    return {
      ...state,
      unmappedSymbols: {
        ...state.unmappedSymbols,
        networkStatus: NetworkStatus.Failed,
      },
    };
  })
  .cases([SymbolLpAction.processing.done, SymbolLpAction.processing.failed], (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(SymbolLpAction.update.done, (state, { params }) => {
    const { lpId, data: updated } = params;
    const { data } = state;
    const recordId = makeLpSymbolCompositeId(lpId, updated.name);

    return {
      ...state,
      data: {
        ...data,
        [recordId]: {
          ...data[recordId],
          ...updated,
        },
      },
    };
  })
  .case(SymbolLpAction.destroy, () => ({
    ...symbolLpInitialState,
  }));
